declare global {
  interface Window {
    Kameleoon: any;
    kameleoonQueue: any;
  }
}

export const useKameleoon = () => {
  const {
    public: { kameleonSiteCode },
  } = useRuntimeConfig();

  const context = useContextStore();

  const profile = useProfileStore();

  const kameleonCode = computed(() => {
    if (!kameleonSiteCode) return [];
    return [
      {
        type: 'text/javascript',
        innerHTML: `
        // Duration in milliseconds to wait while the Kameleoon application file is loaded
        
        var kameleoonLoadingTimeout = 1000;

        window.kameleoonQueue = window.kameleoonQueue || [];
        window.kameleoonStartLoadTime = new Date().getTime();
        if (! document.getElementById("kameleoonLoadingStyleSheet") && ! window.kameleoonDisplayPageTimeOut)
        {
            var kameleoonS = document.getElementsByTagName("script")[0];
            var kameleoonCc = "* { visibility: hidden !important; background-image: none !important; }";
            var kameleoonStn = document.createElement("style");
            kameleoonStn.type = "text/css";
            kameleoonStn.id = "kameleoonLoadingStyleSheet";
            if (kameleoonStn.styleSheet)
            {
                kameleoonStn.styleSheet.cssText = kameleoonCc;
            }
            else
            {
                kameleoonStn.appendChild(document.createTextNode(kameleoonCc));
            }
            kameleoonS.parentNode.insertBefore(kameleoonStn, kameleoonS);
            window.kameleoonDisplayPage = function(fromEngine)
            {
                if (!fromEngine)
                {
                    window.kameleoonTimeout = true;
                }
                if (kameleoonStn.parentNode)
                {
                    kameleoonStn.parentNode.removeChild(kameleoonStn);
                }
            };
            window.kameleoonDisplayPageTimeOut = window.setTimeout(window.kameleoonDisplayPage, kameleoonLoadingTimeout);
        }`,
      },
      {
        src: `//${kameleonSiteCode}.kameleoon.io/engine.js`,
        async: true,
        fetchpriority: 'high',
      },
    ];
  });

  const setMemberId = (id: string) => {
    window.kameleoonQueue = window.kameleoonQueue || [];
    window.kameleoonQueue.push({
      level: 'IMMEDIATE',
      command: () => window.Kameleoon.API.Visitor.setVisitorCode(id),
    });
  };

  const setIsASubscriber = (b: boolean) => {
    window.kameleoonQueue = window.kameleoonQueue || [];

    window.kameleoonQueue.push({
      level: 'IMMEDIATE',
      command: () =>
        window.Kameleoon.API.Data.setCustomData(
          'isASubscriber',
          Boolean(b),
          true
        ),
    });
  };

  const setAccessType = (accessType: string) => {
    window.kameleoonQueue = window.kameleoonQueue || [];
    window.kameleoonQueue.push({
      level: 'IMMEDIATE',
      command: () =>
        window.Kameleoon.API.Data.setCustomData('accessType', accessType, true),
    });
  };

  useHead({
    script: kameleonCode.value as any,
  });

  watch(
    () => context.memberId,
    (id) => {
      if (id) setMemberId(id);
    }
  );

  watch(
    () => context.memberId,
    (id) => {
      if (id) setMemberId(id);
    }
  );

  watch(
    () => profile.isASubscriber,
    (b: boolean) => {
      setIsASubscriber(b);
    }
  );

  watch(
    () => profile.accessType,
    (accessType: string) => {
      setAccessType(accessType);
      setIsASubscriber(profile.isASubscriber);
    }
  );

  onMounted(() => {
    if (context.memberId) {
      setMemberId(context.memberId);
    }
    setIsASubscriber(profile.isASubscriber);
    setAccessType(profile.accessType);
  });
};
